import { useTranslation } from "react-i18next";
import React, { useState } from 'react';

const ChatPopup = ({ phoneNumber, }) => {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [input, setInput] = useState('');

    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    const sendToWhatsApp = () => {
        const message = encodeURIComponent(input);
        const url = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(url, '_blank');
        setInput('');
    };

    return (
        <div>
            {/* Tombol Toggle */}
            {!isOpen && (
                <button
                    onClick={togglePopup}
                    style={{
                        position: 'fixed',
                        bottom: 20,
                        right: 20,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        backgroundColor: '#25D366',
                        color: '#fff',
                        padding: '12px 16px',
                        borderRadius: 30,
                        border: 'none',
                        fontSize: 14,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                        zIndex: 1000,
                    }}
                >
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                        alt="WA"
                        style={{ width: 20, height: 20 }}
                    />
                    {t("chat_whatsapp")}
                </button>
            )}

            {/* Popup Panel */}
            <div
                style={{
                    position: 'fixed',
                    bottom: isOpen ? 20 : -500,
                    right: 20,
                    width: 320,
                    backgroundColor: '#fff',
                    borderRadius: 16,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease',
                    overflow: 'hidden',
                    zIndex: 1000,
                }}
            >
                {/* Header */}
                <div
                    style={{
                        backgroundColor: '#25D366',
                        padding: '16px 20px',
                        color: 'white',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >                    
                    {t("we_are_online")}
                    <button
                        onClick={togglePopup}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: 'white',
                            fontSize: 20,
                            cursor: 'pointer',
                        }}
                        title="Tutup"
                    >
                        ×
                    </button>
                </div>

                {/* Body */}
                <div style={{ padding: '16px 20px', fontSize: 14 }}>
                    {t("chat_hello")}
                </div>

                {/* Input + Kirim */}
                <div
                    style={{
                        padding: '12px 16px',
                        borderTop: '1px solid #eee',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        backgroundColor: '#f9f9f9',
                    }}
                >
                    <input
                        type="text"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && sendToWhatsApp()}
                        placeholder="Ketik pesan..."
                        style={{
                            flex: 1,
                            padding: '10px 12px',
                            border: '1px solid #ccc',
                            borderRadius: 8,
                            fontSize: 14,
                            outline: 'none',
                        }}
                    />
                    <button
                        onClick={sendToWhatsApp}
                        style={{
                            backgroundColor: '#25D366',
                            color: '#fff',
                            border: 'none',
                            padding: '10px 14px',
                            borderRadius: 8,
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            fontSize: 14,
                        }}
                    >
                        {/* Kirim */}
                        {t("kirim")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChatPopup;
